"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _LinodeObjectStorage = /*#__PURE__*/ _interop_require_default(require("./LinodeObjectStorage"));
const _ncplugin = require("~/types/nc-plugin");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let LinodeObjectStoragePlugin = class LinodeObjectStoragePlugin extends _ncplugin.XcStoragePlugin {
    getAdapter() {
        return LinodeObjectStoragePlugin.storageAdapter;
    }
    async init(config) {
        LinodeObjectStoragePlugin.storageAdapter = new _LinodeObjectStorage.default(config);
        await LinodeObjectStoragePlugin.storageAdapter.init();
    }
};
const _default = LinodeObjectStoragePlugin;
